import { useRef, useState } from 'react'
import TextWrapper from '../TextWrapper'
import { iframeStyles } from 'app/constants/iframeStyles'

function AutoMessage({ content, languageInfo }) {
  const [autoMsgHeight, setAutoMsgHeight] = useState(0)
  const [onLoadCalledOnce, setOnLoadCalledOnce] = useState(false)
  const iframeRef = useRef()

  const handleIframeLoad = () => {
    const iframe = iframeRef.current

    if (iframe) {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document

      const iframeBody = iframeDocument.body
      const iframeHead = iframeDocument.head

      const styleElement = iframeDocument.createElement('style')

      styleElement.innerHTML =
        iframeStyles +
        `
        img {
          border-radius: 8px;
        }
        body {
          overflow-wrap: break-word;
        }
      `

      if (iframeHead) {
        iframeDocument.head.appendChild(styleElement)
      }

      iframe.style.height = `${iframeDocument.body.clientHeight}px`
      setAutoMsgHeight(iframeBody?.clientHeight)

      if (iframeBody) {
        iframeBody.dir = languageInfo?.general?.direction ?? 'rtl'
      }

      if (!onLoadCalledOnce) setOnLoadCalledOnce(true)
    }
  }

  return (
    <TextWrapper type="operator">
      <iframe
        style={{ height: `${autoMsgHeight + 20}px` }}
        title="auto_message"
        srcDoc={content}
        onLoad={handleIframeLoad}
        ref={iframeRef}
      />
    </TextWrapper>
  )
}

export default AutoMessage
